/* Petpal redesign — shared interaction layer (ported from the render; NOT the .dc runtime) */
(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function icons(){ if (window.lucide && lucide.createIcons) { try { lucide.createIcons(); } catch(e){} } }

  ready(function () {
    icons(); setTimeout(icons, 400); setTimeout(icons, 1200);

    /* ---- mobile nav drawer ---- */
    var panel = document.querySelector('[data-navpanel]');
    var overlay = document.querySelector('[data-navoverlay]');
    function toggleNav(e){
      if (e) e.preventDefault();
      if (!panel) return;
      var open = panel.classList.toggle('pp-nav-open');
      panel.style.transform = open ? 'translateX(0)' : 'translateX(-100%)';
      if (overlay){ overlay.style.opacity = open ? '1' : '0'; overlay.style.visibility = open ? 'visible' : 'hidden'; }
      document.body.style.overflow = open ? 'hidden' : '';
    }
    document.querySelectorAll('[data-navtoggle]').forEach(function(el){ el.addEventListener('click', toggleNav); });

    /* ---- responsive header (mobile <=900) ---- */
    function applyHeader(){
      var mob = window.innerWidth <= 900;
      var q = function(s){ return document.querySelector(s); };
      var burger=q('[data-mobileburger]'), nav=q('[data-mainnav]'), logo=q('[data-logo]'),
          head=q('[data-headtop]'), quiz=q('[data-quizpill]'), acct=q('[data-acct]');
      if (burger) burger.style.display = mob ? 'block' : 'none';
      if (nav)    nav.style.display    = mob ? 'none'  : 'flex';
      if (quiz)   quiz.style.display   = mob ? 'none'  : 'inline-flex';
      if (acct)   acct.style.display   = mob ? 'none'  : 'inline-flex';
      if (logo)   logo.style.height    = mob ? '95px'  : '125px';
      if (head)   head.style.height    = mob ? '113px' : '146px';
    }
    applyHeader(); window.addEventListener('resize', applyHeader);

    /* ---- cart drawer ---- */
    var drawer = document.querySelector('[data-cart-drawer]');
    function openCart(e){ if (e) e.preventDefault(); if (!drawer){ window.location.href = (window.PP_ROUTES && PP_ROUTES.cart) || '/cart'; return; } drawer.classList.add('pp-cart-open'); drawer.style.transform='translateX(0)'; document.body.style.overflow='hidden'; icons(); }
    function closeCart(){ if (!drawer) return; drawer.classList.remove('pp-cart-open'); drawer.style.transform='translateX(100%)'; document.body.style.overflow=''; }
    document.querySelectorAll('[data-carttoggle]').forEach(function(el){ el.addEventListener('click', openCart); });
    document.querySelectorAll('[data-cartclose]').forEach(function(el){ el.addEventListener('click', closeCart); });

    /* expose for page scripts (homepage pet-seating, PDP, etc. attach their own logic) */
    window.PP = { icons: icons, openCart: openCart, closeCart: closeCart, applyHeader: applyHeader };
  });
})();
